import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { CartService } from "./cart.service";
import { StorageService } from "./storage.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  private url: string = "";
  private dateFormat = "YYYY-MM-DD HH:mm:ss";
  constructor(
    private http: HttpClient,
    private cartService: CartService,
    private storageService: StorageService,
    private router: Router
  ) {
    this.url = environment.urlService;
  }

  async finishOrder(order: any): Promise<boolean> {
    try {
      let result: string = await this.http
        .post<string>(this.url + "ordenes/TerminarOrden", order)
        .toPromise();
      if (result != "true") {
        return false;
      }
    } catch (error) {
      return false;
    }
    return true;
  }

  async getOrderNumber(): Promise<number> {
    try {
      let data = {
        codTienda: this.storageService.getItem("codRestaurante"),
        estacion: "web-menu",
        codUsuario: 19,
      };
      let codOrden = this.storageService.getItem("codOrden");
      if (codOrden != null) {
        return parseInt(codOrden);
      } else {
        let result: string = await this.http
          .post<string>(this.url + "ordenes/nueva", data)
          .toPromise();
        this.storageService.addItem(parseInt(result), "codOrden");
        return parseInt(result);
      }
    } catch (error) {
      return 0;
    }
    return 0;
  }

  getOrderNumberSession(): number {
    let codOrden = this.storageService.getItem("codOrden");
    return codOrden!=null ? parseInt(codOrden): 0;
  }

  async getOrder(name, address, tel, rtn, email, total, paymentMethod): Promise<any> {
    let order: any;
    let codOrden: number = await this.getOrderNumber();
    console.log(codOrden)
    if (codOrden > 0) {
      let stringProductsModifiends: string[] = this.cartService.getProductsModifiersString();
      if (
        stringProductsModifiends != null &&
        stringProductsModifiends.length > 0
      ) {
        return (order = {
          telefono: tel,
          nombre: name,
          rtn: rtn,
          email: email,
          codColonia: 1,
          codUsuarioCobro: 19,
          estacion: "web-menu",
          codOrden: codOrden,
          direccion: address,
          efectivo: 0,
          tarjeta: paymentMethod == "tj" ? total : 0,
          dolares: 0,
          formaPago1: 0,
          formaPago2: 0,
          formaPago3: 0,
          formaPago4: 0,
          formaPago5: 0,
          codDescuento: 0,
          descuento: 0,
          productosDescuento: "",
          diasCredito: 0,
          productos: stringProductsModifiends[0],
          modificadores: stringProductsModifiends[1],
          codMesa: this.storageService.getItem2("codMesa"),
          codCanal: "1",
          enviarCocina: "0",
          puntos: "0",
          propina: "0",
          cupones: "0",
          certificadoConsumo: "0",
          giftCard: "0",
          latitud: 0,
          longitud: 0,
        });
      } else {
        return null;
      }
      return order;
    } else {
      return null;
    }
  }

  sendInvoiceMail(codOrden, email) {
    this.http
      .post(this.url + "ordenes/enviar", { codOrden: codOrden, email: email })
      .subscribe();
  }

  async getOrderAvailable(): Promise<boolean> {
    let codOrden = parseInt(this.storageService.getItem("codOrden"));
    let response = await this.http
      .post<string>(this.url + "orden/valida", { codOrden: codOrden })
      .toPromise();
    return response == "1" ? true : false;
  }

  async getTableAvailable(): Promise<boolean> {
    let codMesa = this.storageService.getItem2("codMesa");
    let response = await this.http
      .post<string>(this.url + "orden/mesaDisponible", { codMesa: codMesa })
      .toPromise();
    return response == "0" ? true : false;
  }

  clearQR() {
    this.storageService.removeItem("codRestaurante");
    this.storageService.removeItem("codMesa");
  }

  async validate(id): Promise<boolean> {
    //id = atob(id);

    let cods = id.split("&");
    let response = await this.http
      .post<any>(this.url + "validaRestauranteMesa", {
        codRestaurante: cods[0],
        codMesa: cods[1],
      })
      .toPromise();
    if (response.respuesta === '1') {
      this.storageService.removeItem("codRestaurante");
      this.storageService.removeItem("codMesa");
      this.storageService.removeItem("descripcionMesa");
      this.storageService.removeItem("codOrden");
      this.storageService.removeItem("cart");
      this.storageService.removeItem("scanTime");
      this.storageService.removeItem("scan");
      this.storageService.removeItem("client");
      let date = moment(new Date()).format(this.dateFormat);
      this.storageService.addItem(date, "scanTime");
      this.storageService.addItem(true, "scan");
      this.storageService.addItem(cods[0], "codRestaurante");
      this.storageService.addItem(cods[1], "codMesa");
      this.storageService.addItem(response.mensaje, "descripcionMesa");
      return true;
    } else {
      return false;
    }
  }

  async validate2(codMesa, codRestaurante) {
    let date = moment(
      this.storageService.getItem2("scanTime"),
      this.dateFormat
    );

    let newDate = moment(new Date()).format(this.dateFormat);
    let currentTime = moment(newDate);
    let diff = moment.duration(currentTime.diff(date)).minutes();
    if (diff > 60) {
      this.clearQR();
      window.location.href = "https://2mnu.com";
    } else {
      let response = await this.http
        .post<any>(this.url + "validaRestauranteMesa", {
          codRestaurante: codRestaurante,
          codMesa: codMesa,
        })
        .toPromise();
      if (response.respuesta != "1") {
        window.location.href = "https://2mnu.com";
      }
    }
  }

  async validateSession() {
    let codMesa = this.storageService.getItem2("codMesa");
    let codRestaurante = this.storageService.getItem2("codRestaurante");
    await this.validate2(codMesa, codRestaurante);
    /*this.storageService.addItem("11", "codRestaurante");
      this.storageService.addItem("1", "codMesa");*/
  }

  saveRefCardTransaction(AuthorizeResult: any, codOrden, monto) {
    let response = this.http
      .post<string>(this.url + "orden/card_transaction", {
        codOrden: codOrden,
        monto: monto,
        AuthCode: AuthorizeResult.CreditCardTransactionResults.AuthCode,
        OriginalResponseCode:
          AuthorizeResult.CreditCardTransactionResults.OriginalResponseCode,
        PaddedCardNumber:
          AuthorizeResult.CreditCardTransactionResults.PaddedCardNumber,
        ReasonCode: AuthorizeResult.CreditCardTransactionResults.ReasonCode,
        ReasonCodeDescription:
          AuthorizeResult.CreditCardTransactionResults.ReasonCodeDescription,
        ReferenceNumber:
          AuthorizeResult.CreditCardTransactionResults.ReferenceNumber,
        ResponseCode: AuthorizeResult.CreditCardTransactionResults.ResponseCode,
        MerchantId: AuthorizeResult.MerchantId,
        OrderNumber: AuthorizeResult.OrderNumber,
      })
      .subscribe();
  }

  saveRefCardTransaction2(TransactionStatusResult: any, codOrden, monto) {
    let response = this.http
      .post<string>(this.url + "orden/card_transaction", {
        codOrden: codOrden,
        monto: monto,
        AuthCode: TransactionStatusResult.CreditCardTransactionResults.AuthCode,
        OriginalResponseCode:
          TransactionStatusResult.CreditCardTransactionResults
            .OriginalResponseCode,
        PaddedCardNumber:
          TransactionStatusResult.CreditCardTransactionResults.PaddedCardNumber,
        ReasonCode:
          TransactionStatusResult.CreditCardTransactionResults.ReasonCode,
        ReasonCodeDescription:
          TransactionStatusResult.CreditCardTransactionResults
            .ReasonCodeDescription,
        ReferenceNumber:
          TransactionStatusResult.CreditCardTransactionResults.ReferenceNumber,
        ResponseCode:
          TransactionStatusResult.CreditCardTransactionResults.ResponseCode,
        MerchantId: TransactionStatusResult.MerchantId,
        OrderNumber: TransactionStatusResult.OrderNumber,
      })
      .subscribe();
  }

  saveCardTransaction(orderNumber, codOrden, monto) {
    let response = this.http
      .post<any>(this.url + "orden/statusPay", {
        orderNumber: orderNumber,
      })
      .subscribe((data) => {
        this.saveRefCardTransaction2(
          data.TransactionStatusResult,
          codOrden,
          monto
        );
      });
  }

  async payCardCreditOrder(
    codOrden,
    total,
    cardNumber,
    cardNumber2,
    month,
    year,
    ccv,
    holder,
    order
  ): Promise<any> {
    return await this.http
      .post<any>(this.url + "orden/authorizePay", {
        codOrden: codOrden,
        total: total,
        numeroTarjeta: cardNumber,
        cardNumber2: cardNumber2,
        mes: month,
        anio: year,
        ccv: ccv,
        titular: holder,
        order: order
      })
      .toPromise();

  }

  async getOrdenesMesa(): Promise<any> {
    return await this.http
      .post<any>(this.url + "ordenesMesa", {
        codMesa: this.storageService.getItem('codMesa')
      })
      .toPromise();
  }

  async getOrdenesMesaCount(): Promise<any> {
    return await this.http
      .post<any>(this.url + "ordenesMesaCount", {
        codMesa: this.storageService.getItem('codMesa')
      })
      .toPromise();
  }

  async getOrdenMesa(): Promise<any> {
    return await this.http
      .post<any>(this.url + "ordenMesa", {
        codOrden: this.storageService.getItem('codOrden')
      })
      .toPromise();
  }

  async getLogo(): Promise<string> {
    let result: string = await this.http.get<string>(this.url + 'logo').toPromise();
    return result;
  }

  getCodMesa():string {
    return this.storageService.getItem('codMesa');
  }

  getMesa(): string {
    return this.storageService.getItem2("descripcionMesa");
  }

  getScan() {
    return this.storageService.getItem("scan");
  }

  removeScan() {
     this.storageService.removeItem("scan");
  }

  setOrder(order:any){
    this.storageService.addItem(order.detalle,'cart');
    this.storageService.addItem(order.cliente,'client');
    this.storageService.addItem(order.codOrden,'codOrden');
  }

  updateOrder(order:any){
    let currentProducts = this.cartService.getProductList();
    let pendingProducts = currentProducts.filter(product => !product.procesado );;
    this.storageService.addItem(order.detalle,'cart');
    pendingProducts.forEach(product => {
      this.cartService.addCart(product);
    });
    this.storageService.addItem(order.cliente,'client');
    this.storageService.addItem(order.codOrden,'codOrden');
  }

}
